<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa240-main container-height">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                  :useBtnList="[
                      'btnRetrieve', //Retrieve
                      'btnExcel',   //Save Excel
                      'btnPrint' // Save Pdf
                    ]" @btnRetrieve="btnRetrieve()" @btnExcel="onExporting()" @btnPrint="onExportingPdf()">

                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2 pb-0">
                      <v-icon small color="blue">mdi-circle</v-icon>
                      <span class="pa-1 subTitle">Cutter : </span>
                          <v-col cols="1">
                            <v-select
                              v-model="cutMaker"
                              :items="cutMakerList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              outlined
                              dense
                              height="32"
                            />
                          </v-col>
                          <i-label :label="'Closing time :'" />
                          <v-col cols="1">
                            <v-select
                              v-model="selectYear"
                              :items="yearList"
                              single-line
                              outlined
                              dense
                              height="32" />
                          </v-col>
                          
                          <v-col cols="1">
                            <v-select
                              v-model="selectMonth"
                              :items="monthList"
                              single-line
                              outlined
                              dense
                              height="32" />
                          </v-col>
                         
                          <v-col cols="1">
                            <v-select
                              v-model="selectTimes"
                              :items="timesList"
                              single-line
                              outlined
                              dense
                              height="32" />
                          </v-col>

                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="pa-2 pr-0"> Division: </span>
                          <v-col cols="2">
                            <v-select
                              v-model="rptDiv"
                              :items="rptDivList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>                                                 
                        
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">Ship No. : </span>
                          <v-col cols="1">
                              <v-select
                                v-model="shipNo"
                                :items="shipNoList"
                                item-value="shipNo"
                                return-object
                                single-line
                                outlined
                                dense
                                label="Select"
                                @change="getBlock()"
                              ></v-select>
                          </v-col>
                        
                        <v-icon small color="blue">mdi-circle</v-icon>
                        <span class="pa-1 subTitle">Block : </span>
                          <v-col cols="1">
                            <v-select
                              v-model="block"
                              :items="blockList"
                              single-line
                              outlined
                              dense
                              height="32"
                            />
                          </v-col>

                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>
            
            <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epmsa240" 
                    class="listBox" 
                    :ref="epmsa240Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"    
                    @cellPrepared="cellPrepared"                                   
                  >
                  <DxGroupPanel :visible="true"/>
                  <DxGrouping :auto-expand-all="true"/>
                    <DxExport :enabled="true"  />
                    <DxPaging :enabled="false" />
                    <DxPager :visible="false" />

                    <DxEditing :use-icons="true" mode="cell" />                    
                    <DxColumn :group-index="0" data-field="groupNm" caption="Ship" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="id" caption="No" width="2%" data-type="string" alignment="left" :allow-editing="false"/> 
                    <DxColumn data-field="shipNo" caption="Ship No" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="lotNo" caption="Lot No" width="4%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="cutGrp" caption="Group" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="DRAWING" alignment="center" :allow-editing="false" >                      
                      <DxColumn data-field="dwgNo" caption="Dwg.Page" width="4%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="listMach" caption="Machine" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                      <DxColumn data-field="pcsQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                      <DxColumn data-field="pcsWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>
                    
                    <DxColumn caption="CUTTING" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="cutDte" caption="Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="cutQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="cutWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn caption="CUT CONFIRM" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="cnfDte" caption="Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="cnfQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="cnfWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn caption="REQUEST ASSY" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="reqDte" caption="Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="reqQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="reqWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn caption="DELIVERY" alignment="center" :allow-editing="false" >
                        <DxColumn data-field="dlyDte" caption="Date" width="6%" data-type="string" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="dlyQty" caption="Q'ty" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="dlyWgt" caption="Weight" width="5%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                    </DxColumn>

                    <DxColumn data-field="cutMakerNm" caption="Cutting Maker" width="5%" data-type="string" alignment="center" header-cell-template="cutMakerNmTemp" :allow-editing="false"/>                    
                    <template #cutMakerNmTemp>
                      <div> Cutting<br>Maker</div>
                    </template>   
                    <DxColumn data-field="rankNo" caption="Rank" width="3%" data-type="number" alignment="center" :allow-editing="false"/>                   
                    <DxSummary >
                      <DxTotalItem column="shipNo" summary-type="count" display-format="TOTAL" />
                      <DxTotalItem column="pcsQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxGroupItem  :show-in-group-footer="false"
                                    :align-by-column="true"
                                    column="pcsQty"
                                    summary-type="sum"
                                    value-format= "#,###"
                                    display-format="{0}" />                      
                      <DxTotalItem column="pcsWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxGroupItem  :show-in-group-footer="false"
                                    :align-by-column="true"
                                    column="pcsWgt"
                                    summary-type="sum"
                                    value-format= "#,###"
                                    display-format="{0}" /> 
                      <DxTotalItem column="cutQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxGroupItem  :show-in-group-footer="false"
                                    :align-by-column="true"
                                    column="cutQty"
                                    summary-type="sum"
                                    value-format= "#,###"
                                    display-format="{0}" />                      
                      <DxTotalItem column="cutWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxGroupItem  :show-in-group-footer="false"
                                    :align-by-column="true"
                                    column="cutWgt"
                                    summary-type="sum"
                                    value-format= "#,###"
                                    display-format="{0}" />       
                      <DxTotalItem column="cnfQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxGroupItem
                          :show-in-group-footer="false"
                          :align-by-column="true"
                          column="cnfQty"
                          summary-type="sum"  
                          value-format= "#,###"                                                
                          display-format="{0}"
                        />
                      <DxTotalItem column="cnfWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxGroupItem
                          :show-in-group-footer="false"
                          :align-by-column="true"
                          column="cnfWgt"
                          summary-type="sum"  
                          value-format= "#,###"                                                
                          display-format="{0}"
                        />
                      <DxTotalItem column="reqQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="reqWgt" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="dlyQty" summary-type="sum" :customize-text="totalFormat" />
                      <DxTotalItem column="dlyWgt" summary-type="sum" :customize-text="totalFormat" />
                    </DxSummary>
                  </DxDataGrid>
                </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxExport,
    DxLookup,
    DxSelection,
    DxPager,
    DxGrouping,
   DxGroupPanel,
   DxGroupItem
} from 'devextreme-vue/data-grid'
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { epmsa240, epmsa240Xls, getCutMakerList, getBlockList } from '@/api/view/hip/A/epmsa240'
import { getShipNoList} from '@/api/view/hip/A/epmsa010_kl'
import { getNumComma, toNum } from '@/utils/common.js'
import { getDateFormat, getCurrentDate } from '@/utils/common.js'
import dayjs from 'dayjs';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { getCmChildCode } from '@/api/system/cmCodeManage'
// import { reportView } from '@/api/view/hip/common/common'

export default {
  name: 'epmsa240',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxDateBox,
    DxExport,
    DxLookup,
    DxSelection,
    DxPager,
    DxGrouping,
    DxGroupPanel,
    DxGroupItem    
},

  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' ,'btnExcel','btnPrint'],
      epmsa240Ref: 'epmsa240Ref',
      gridMainList: [],
      shipNoList: [],
      makerCd: this.$store.state.user.makerCd,
      shipNo: '',
      block: '',
      blockList: [],
      cutMaker: '',
      cutMakerList: [],
      stDate: null,
      edDate: null,
      rptDiv: '',
      rptDivList: [],
      format: '#,##0.##',
      selectYear: '',
      yearList: [],
      selectMonth: '',
      monthList: [],
      selectTimes: '',
      timesList: [],
      //cell merge
      mergeElements: [],
      mergeStartElements: [],
      //cell merge
      mergeElements1: [],
      mergeStartElements1: [],
      //cell merge
      mergeElements2: [],
      mergeStartElements2: []
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa240Ref)
    },
  },
  mounted() {
    this.init()
    //this.gridMainInstance.option('defaultPaging', false)
    //this.getList() 
    //this.btnRetrieve()
  },
  methods: {
    totalFormat(e) {
        const result = getNumComma(Number(e.value.toFixed(2)), 2)
        return result
    },
    getStrFormat(date) {
        return getDateFormat(date)
    },
    init() {
        this.gridInstance.option('defaultPaging', false)
        let toDay = new Date
        this.stDate = toDay.setDate(toDay.getDate() - 7);
        //console.log(this.stDate) ;

        toDay = new Date
        this.edDate = toDay.setDate(toDay.getDate());

        this.stDate = dayjs(this.stDate).format('YYYY-MM-DD')
        this.edDate = dayjs(this.edDate).format('YYYY-MM-DD')

        this.getYMT()
        this.getList()
        
    },    
    getYMT() {
      const now = getCurrentDate().split('-')

      this.yearList = ['2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028']
      this.selectYear = now[0]

      this.monthList = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
      this.selectMonth = now[1]

      this.timesList = ['1', '2', '3']
      if(Number(now[2]) <= 10) {
        this.selectTimes = '1'
      } else if(Number(now[2]) <= 20) {
        this.selectTimes = '2'
      } else if(Number(now[2]) <= 31) {
        this.selectTimes = '3'
      }
    }, 
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          code: '',
          codegr: '',
          prtCode: 'INV_DIV',
          userFlag: 'Y'
        }
        await getCmChildCode(params).then(res => {
          this.rptDivList = res.list
          this.rptDiv     = res.list[0]
        })

        let param = {
          makerCd: this.$store.state.user.makerCd
        }
        await getShipNoList(param).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;
        })

        await getCutMakerList(param).then(res => {
          this.cutMakerList.push({ code: '', codeName: '' });
          
          res.list.forEach(e => {
            this.cutMakerList.push({
              code: e.cutMakerId,
              codeName: e.cutMakerNm || ''
            })
          })
        
          if(this.makerCd ==='11951' || this.makerCd ==='14017') {
            this.cutMaker = this.cutMakerList[1];
          }else {
            this.cutMaker = this.cutMakerList[2];
          } ;
        
        })
      
      } finally {
      this.endLoading()
      }
    },
    async getBlock(){
      let param = {
        shipNo: this.shipNo
      }
      this.openLoading('searching')
      await getBlockList(param).then(res => {
        this.blockList = []
        this.blockList.push('')
        res.list.forEach(e => {
          this.blockList.push(e.block)
        });
        this.block = this.blockList[0]
      }).finally(() => {
        this.endLoading()
      })
    },

    async getMainList(){
      this.gridMainList = []
      try {
        this.openLoading('searching')
        let params = {
          shipNo : this.shipNo,
          block: this.block,
          cutMakerId: this.cutMaker.code,
          closeTimes: this.selectYear + this.selectMonth + this.selectTimes,        
          rptDiv: this.rptDiv.code
        }
        console.log(params)
        await epmsa240(params).then(res => {
          let list = []
          let cnt = 1;
          res.list.forEach(e => {
            list.push(
              {
                id: cnt++ ,  shipNo: e.shipNo, lotNo: e.lotNo, cutGrp: e.cutGrp, 
                dwgNo : e.dwgNo,
                pcsQty: e.pcsQty,  pcsWgt: e.pcsWgt, 
                cutDte: e.cutDte, cutQty : e.cutQty, cutWgt : e.cutWgt,
                cnfDte: e.cnfDte, cnfQty : e.cnfQty, cnfWgt : e.cnfWgt,
                reqDte: e.reqDte, reqQty : e.reqQty, reqWgt : e.reqWgt,
                dlyDte: e.dlyDte, dlyQty : e.dlyQty, dlyWgt : e.dlyWgt,
                cutMakerNm: e.cutMakerNm,
                listMach : e.listMach,
                groupNm : e.groupNm,
                rankNo : e.rankNo
              }
            )
          });
          //console.log(res.list)
          //this.gridMainList = res.list
          this.gridMainList = list
        })
      } finally {
      this.endLoading()
      }
    },
    btnRetrieve(){
      this.gridMainList = []
      this.getMainList()
    },
    // btnExcel(){
    //   this.openLoading('searching')
    //   // const param = {
    //   //     shipNo : this.shipNo,
    //   //     block: this.block,
    //   //     cutMakerId: this.cutMaker.code,
    //   //     stDte: this.stDate,
    //   //     edDte: this.edDate,
    //   //     rptDiv: this.rptDiv.code
    //   // }
    //   // epmsa240Xls(param)
    //   this.onExporting() 
    //   this.endLoading()
    // },
    onExporting(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('sheet');

        // 1. Khai báo danh sách các dataField của cột mà bạn muốn merge (SỬA LẠI THEO TÊN CỘT CỦA BẠN)
        const fieldsToMerge = ['cnfDte', 'cnfQty', 'cnfWgt']; 

        exportDataGrid({
          component: this.gridInstance,
          worksheet,
          topLeftCell: { row: 4, column: 1 },
          groupDataByKey: true
        }).then((cellRange) => {

          // --- CÁC FORMAT HEADER VÀ ĐIỀU KIỆN CỦA BẠN (GIỮ NGUYÊN) ---
          const titleRow = worksheet.getRow(2);
          titleRow.height = 30;
          worksheet.mergeCells(2, 1, 2, 19);

          titleRow.getCell(1).value = 'Cutting Result Follow Up';
          titleRow.getCell(1).font = { name: 'Segoe UI Light', size: 22, bold: true };
          titleRow.getCell(1).alignment = { horizontal: 'center' , vertical: 'middle' } ;

          const condRow = worksheet.getRow(3);
          condRow.height = 20;
          worksheet.mergeCells(3, 1, 3, 19);

          let strCond = 'Cutting duration: ' + this.stDate + ' ~ ' + this.edDate;
          condRow.getCell(1).value = strCond;
          condRow.getCell(1).font = { name: 'Calibri', size: 12, bold: true };
          condRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };

          const headerRow = worksheet.getRow(4);
          const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
          const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, top: {style: 'thin', fgColor: { argb: 'bfbfbf' }}, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
          let headerRowLength = headerRow._cells.length       

          for(let i = 4; i <= headerRowLength; i++){
            headerRow.getCell(i).fill = headerStyle
            headerRow.getCell(i).border = headerBorderStyle
            headerRow.getCell(i).alignment = { horizontal: 'center', vertical: 'middle' }
          }

          for(let j = 4; j <= worksheet._rows.length; j++){
            for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){
                if (j == 4 || j == 5) {
                  worksheet.getRow(j).getCell(a).fill = headerStyle
                }
                worksheet.getRow(j).getCell(a).border = headerBorderStyle
            }
          }

          // --- THÊM LOGIC MERGE DÒNG THEO RANK_NO ---

          // Lấy danh sách các dòng dữ liệu và cột đang hiển thị
          //const visibleRows = this.gridInstance.getVisibleRows();
          //const dataRows = visibleRows.filter(r => r.rowType === 'data');
          const dataRows = this.gridInstance.getVisibleRows();
          const visibleColumns = this.gridInstance.getVisibleColumns();
          
          // LỌC BỎ các cột không được export ra Excel (Checkbox, Action Buttons, Expand...)
          const exportedColumns = visibleColumns.filter(c => 
            c.type !== 'selection' && 
            c.type !== 'buttons' && 
            c.type !== 'detailExpand'
          );

          // Tìm index (số thứ tự) của các cột Excel cần merge
          const colIndicesToMerge = fieldsToMerge.map(field => {
            let colIndex = exportedColumns.findIndex(c => c.dataField === field);
            return colIndex !== -1 ? colIndex + cellRange.from.column - 1 : -1;
          }).filter(idx => idx !== -1);

          if (dataRows.length > 0 && colIndicesToMerge.length > 0) {
            // Tính dòng Excel đầu tiên chứa dữ liệu            
            let currentExcelRow = 6;                      
            let mergeStartRow = -1;          

            for (let i = 0; i < dataRows.length; i++) {

              let row = dataRows[i];                            
              if(row.rowType === 'group'){

                 // 1. Gặp dòng group -> Ngắt quá trình merge hiện tại (nếu có)
                if (mergeStartRow !== -1 && mergeStartRow < currentExcelRow - 1) {
                  colIndicesToMerge.forEach(colIndex => {
                  worksheet.mergeCells(mergeStartRow, colIndex, currentExcelRow - 1, colIndex);
                });
               }
                // Reset lại điểm bắt đầu merge
                mergeStartRow = -1;                
              }
              if(row.rowType === 'data'){                                
              // Đảm bảo đúng tên trường rank_no trong data của bạn
              let rankNo = Number(dataRows[i].data.rankNo); 

              if (rankNo === 1) {
                // Nếu trước đó đã có một nhóm bắt đầu, ta merge nhóm đó lại
                if (mergeStartRow !== -1 && mergeStartRow < currentExcelRow - 1) {
                  colIndicesToMerge.forEach(colIndex => {
                    worksheet.mergeCells(mergeStartRow, colIndex, currentExcelRow - 1, colIndex);
                  });
                }
                // Đánh dấu dòng bắt đầu cho nhóm mới
                mergeStartRow = currentExcelRow;
              }              
            }               
            currentExcelRow ++ ;            
          }
          // Xử lý merge cho nhóm cuối cùng khi vòng lặp chạy đến dòng cuối          
          if (mergeStartRow !== -1 && mergeStartRow < currentExcelRow - 1) {
            colIndicesToMerge.forEach(colIndex => {
              worksheet.mergeCells(mergeStartRow, colIndex, currentExcelRow - 1, colIndex);
            });
          }
              
        }
          // --- KẾT THÚC LOGIC MERGE ---
        })
        .then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CuttingResult.xlsx');
          });
        }); 

        this.gridInstance.cancel = true; // Ngăn chặn DevExtreme tự động xuất file mặc định
      },      
      onExportingPdf(e) {         
          const doc = new jsPDF({
                orientation: 'landscape',  // 'landscape' hoặc 'portrait'
                unit: 'mm',
                format: 'A3',  // hoặc 'letter', 'a3', etc.              
            });
            const pageWidth = doc.internal.pageSize.getWidth();
            doc.setFontSize(16);
            //doc.setFont(undefined, 'bold');
            doc.text('Cutting Result Follow Up', pageWidth / 2, 10, { align: 'center' });

            exportDataGridToPdf({
                jsPDFDocument: doc,
                component: this.gridInstance,
                topLeftCell: { row: 0, column: 0 },
                indent: 5,
                autoTableLayout: true,                
            }).then(() => {
                doc.save('Cutting Result Follow Up.pdf');
            });      

        this.gridInstance.cancel = true;
      },

      cellPrepared(e){
      if (e.rowType === 'data') {
            
        e.cellElement.style.padding = '1px'
        this.merge('cnfDte', this.mergeElements, this.mergeStartElements, e)
        this.merge('cnfQty', this.mergeElements1, this.mergeStartElements1, e)
        this.merge('cnfWgt', this.mergeElements2, this.mergeStartElements2, e)
      }
    },
    merge(filed, mergeEle, mergeEleStart, e) {
      // Bỏ qua nếu không phải là dòng dữ liệu (tránh lỗi với header/footer)
      if (e.rowType !== 'data') return;

      if (e.column.dataField === filed) {
        e.cellElement.style['vertical-align'] = 'middle';
        
        // Lấy giá trị rankNo của dòng hiện tại
        // Đảm bảo tên trường 'rankNo' khớp với tên property trong data của bạn
        let currentRankNo = Number(e.data.rankNo); 

        if (this.curRowIndex + 1 !== this.gridMainList.length) {
          if (e.rowIndex > 0) {
            
            // NẾU LÀ DÒNG SỐ 2, 3, 4... (CẦN MERGE VÀO DÒNG 1)
            if (currentRankNo > 1) {
              var prev = mergeEle[e.rowIndex - 1];
              
              if (!mergeEle[e.rowIndex]) {
                mergeEle[e.rowIndex] = {};
              }
              mergeEle[e.rowIndex] = prev;
              mergeEleStart[e.rowIndex] = prev;
              
              if (prev) {
                let curCellElement = e.cellElement;
                curCellElement.style.display = 'none'; // Ẩn ô hiện tại

                var span = prev.getAttribute('rowspan');
                if (span) {
                  prev.setAttribute('rowspan', Number(span) + 1); // Tăng rowspan cho dòng 1
                } else {
                  prev.setAttribute('rowspan', 2);
                }
                this.nonDispalyedRowIndex.push(e.rowIndex);
              }
            } 
            // NẾU LÀ DÒNG 1 (BẮT ĐẦU NHÓM MỚI) HOẶC RANK KHÔNG XÁC ĐỊNH
            else {
              if (!mergeEle[e.rowIndex]) mergeEle[e.rowIndex] = {};
              mergeEle[e.rowIndex] = e.cellElement; // Lưu lại DOM của dòng 1 để các dòng sau merge vào
            }
          } else {
            // Khi là dòng đầu tiên của Grid (rowIndex === 0)
            if (!mergeEle[e.rowIndex]) {
              mergeEle[e.rowIndex] = {};
            }
            mergeEle[e.rowIndex] = e.cellElement;
          }
          this.curRowIndex = e.rowIndex;
        } else {
          // Logic của bạn khi cuộn/click (giữ nguyên)
          if (this.nonDispalyedRowIndex.indexOf(e.rowIndex) !== -1) {
            e.cellElement.style.display = 'none';
          } else {
            if (typeof mergeEleStart[e.rowIndex + 1] === 'undefined') return;
            let rowspan = mergeEleStart[e.rowIndex + 1].getAttribute('rowspan');
            if (rowspan) {
              e.cellElement.setAttribute('rowspan', rowspan);
            }
          }
        }
        // Loại bỏ trùng lặp trong mảng nonDispalyedRowIndex
        const set = new Set(this.nonDispalyedRowIndex);
        this.nonDispalyedRowIndex = [...set];
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.epmsa240-main {
  .subTitle {
    font-weight: bold;
    color: black;
  }
}
</style>